import { Landmark, QrCode, ShieldCheck, MessageCircle } from "lucide-react";

const steps = {
  bank: [
    {
      icon: Landmark,
      title: "Buka aplikasi m-banking Anda",
      desc: "Login ke BCA / Mandiri / BRI mobile banking atau internet banking.",
    },
    {
      icon: Landmark,
      title: "Pilih menu Transfer",
      desc: "Transfer ke rekening Teras Alami: 1234567890 a.n. Teras Alami Indonesia.",
    },
    {
      icon: ShieldCheck,
      title: "Masukkan nominal sesuai total",
      desc: "Pastikan nominal transfer SAMA PERSIS dengan total tagihan.",
    },
    {
      icon: MessageCircle,
      title: "Konfirmasi pembayaran",
      desc: "Setelah transfer, klik tombol “Saya Sudah Bayar” atau hubungi WhatsApp admin.",
    },
  ],
  qris: [
    {
      icon: QrCode,
      title: "Buka aplikasi e-wallet/m-banking",
      desc: "GoPay, OVO, Dana, ShopeePay, LinkAja, atau m-banking dengan fitur QRIS.",
    },
    {
      icon: QrCode,
      title: "Scan QRIS yang tampil",
      desc: "QR Code akan muncul di halaman pembayaran. Pastikan nominal sesuai.",
    },
    {
      icon: ShieldCheck,
      title: "Periksa & konfirmasi",
      desc: "Cek nama penerima: Teras Alami Indonesia, lalu lanjutkan pembayaran.",
    },
    {
      icon: MessageCircle,
      title: "Tekan “Saya Sudah Bayar”",
      desc: "Sistem akan memverifikasi pembayaran Anda dalam beberapa menit.",
    },
  ],
  cod: [
    {
      icon: ShieldCheck,
      title: "Pesanan akan dikirim",
      desc: "Kurir akan mengantarkan pesanan ke alamat Anda.",
    },
    {
      icon: Landmark,
      title: "Siapkan uang pas",
      desc: "Mohon siapkan uang pas sesuai total pembayaran.",
    },
    {
      icon: MessageCircle,
      title: "Bayar ke kurir",
      desc: "Bayarkan total kepada kurir ketika paket sampai.",
    },
    {
      icon: ShieldCheck,
      title: "Pesanan selesai",
      desc: "Tekan tombol “Saya Sudah Bayar” setelah menerima pesanan.",
    },
  ],
};

const PaymentTutorial = ({ type = "bank" }) => {
  const list = steps[type] || steps.bank;

  return (
    <div
      className="bg-white border border-stone-200 rounded-2xl p-6 sm:p-8 shadow-sm"
      data-testid="payment-tutorial"
    >
      <h3 className="font-display text-2xl font-semibold text-stone-900 mb-1">
        Tutorial Pembayaran
      </h3>
      <p className="text-stone-600 mb-6">
        Ikuti langkah berikut agar pembayaran Anda berhasil diverifikasi.
      </p>

      <ol className="space-y-5">
        {list.map((s, i) => {
          const Icon = s.icon;
          return (
            <li key={i} className="flex gap-4">
              <div className="flex flex-col items-center">
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-emerald-50 text-emerald-700 border border-emerald-100">
                  <Icon className="w-5 h-5" />
                </span>
                {i < list.length - 1 && (
                  <span className="w-px flex-1 bg-stone-200 my-2"></span>
                )}
              </div>
              <div className="pb-2">
                <p className="font-display text-lg font-medium text-stone-900">
                  {i + 1}. {s.title}
                </p>
                <p className="text-stone-600 mt-1">{s.desc}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default PaymentTutorial;
